import axios from 'axios';
import Key from '../../../clientVariables.json';
import { GET_CONTRACT_ACTION, SELECTED_CONTRACT, SELECTED_CONTRACT_INVOICE_DATA } from './actionTypes';

export const setContractsAction = (data) => {
  console.log('contract action ', data);
  return async (dispatch) => {
    dispatch({
      type: GET_CONTRACT_ACTION,
      payload: data,
    });
  };
};

// export const setSelectedContractAction = (data) => {
//   return async (dispatch) => {
//     try {
//       const response = await axios.get(`${Key.domain}/payment/contract/${data?.customer_id}`);
//       dispatch({
//         type: SELECTED_CONTRACT,
//         payload: response.data.data || {},
//       });
//     } catch (error) {
//       console.error('Error fetching contract:', error);
//     }
//   };
// };

export const setSelectedContractAction = (data) => {
  return async (dispatch) => {
    if (!data?.customer_id) {
      console.error('Customer ID is missing.');
      return;
    }
    try {
      const response = await axios.get(`${Key.domain}/payment/contract/${data.customer_id}`);
      const contractData = response.data?.data || {};

      dispatch({
        type: SELECTED_CONTRACT,
        payload: contractData,
      });
    } catch (error) {
      console.error('Error fetching contract:', error);
      // dispatch({
      //   type: 'FETCH_CONTRACT_ERROR',
      //   payload: { error: error.message },
      // });
    }
  };
};

export const setSelectedContractInvoiceDataAction = (data) => {
  console.log(data);
    return async (dispatch) => {
      dispatch({
        type: SELECTED_CONTRACT_INVOICE_DATA,
        payload: data,
      });
    };
};